// extracted by mini-css-extract-plugin
export default {"thread-header":"Thread_thread-header__ga7iz","back":"Thread_back__OWYQS","back-btn":"Thread_back-btn__xuVQr","info":"Thread_info__G6he3"};